import angular from 'angular';
import 'geo-distance';
const Distance = window.Distance;

module.exports = angular.module('common.filters.relative-distance', [])
.filter('distance', function() {
  return function(from, to) {
    if (
      from && from.latitude && from.longitude &&
      to && to.latitude && to.longitude
    ) {
      const fromObj = { lat: from.latitude, lon: from.longitude };
      const toObj = { lat: to.latitude, lon: to.longitude };
      return Distance.between(fromObj, toObj)
        .human_readable_in_units('miles')
        .toString();
    } else {
      return '- miles';
    }
  };
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/relative-distance.js
 **/